export default {
  'navbar.pricing': 'Pricing',
  'navbar.companies': 'For companies',
  'navbar.personal': 'For personal users',
  'navbar.news': 'News',
  'navbar.usersCases': 'Users Cases',
  'navbar.logoText': 'Getfloorplan',
};
